import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { BlockInteractions, createButtonObject, DISPLAY_TYPE, Views } from '../../organisms/BlockInteractions';
import BlockFetcher from '../../hocs/BlockFetcher/BlockFetcher';
import EventCreateOrUpdate from './forms/EventCreateOrUpdate';
import EventDetailsView from './partials/EventDetailsView';
import { Icons } from '../../atoms/SVG';
import { Namespace } from '../../../translation/namespace';
import FormActionShape from '../../../lib/shapes/FormActionShape';

const DefaultView = BlockFetcher()(EventDetailsView);
const EditView = BlockFetcher()(EventCreateOrUpdate);

function EventDetails({ elementType, uuid, views, activeView = null, refresh, refreshCount }) {
  const createButtonsObject = () => {
    return createButtonObject(
      Views.EDIT,
      Icons.EDIT_PENCIL,
      'EventDetails:edit',
      DISPLAY_TYPE.COLLAPSIBLE,
      <EditView
        additionalProps={{
          refreshBlock: refresh,
          translationNamespace: 'EventDetails:edit',
        }}
        {...views[Views.EDIT]}
      />
    );
  };

  const { t } = useTranslation(Namespace.EventDetails);

  return (
    <BlockInteractions
      uuid={uuid}
      elementType={elementType}
      headline={{ text: t('headline'), hierarchy: 2, visible: true }}
      buttons={createButtonsObject()}
      views={views}
      refreshCount={refreshCount}
      activeView={activeView}
      refreshBlock={refresh}
    >
      <DefaultView {...views.default} />
    </BlockInteractions>
  );
}

EventDetails.propTypes = {
  elementType: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
  views: FormActionShape.isRequired,
  activeView: PropTypes.string,
  refresh: PropTypes.func.isRequired,
  refreshCount: PropTypes.number.isRequired,
};

export default EventDetails;
